import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ColorService } from '../../shared/services/color.service';
import { ColorItemComponent } from './color-item.component'
@Injectable()
export class Color implements CanDeactivate<ColorItemComponent> {
  constructor(private colorService: ColorService
  ) {

  }
  canDeactivate(component: ColorItemComponent) {
    if (!this.colorService.canMoveFromColorComponent) {
      return window.confirm("Changes will be discarded. Do you want to leave the page?")
    }
    return this.colorService.canMoveFromColorComponent;
  }

}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/color/color.guard.ts